import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'georgian-lari',
  size: 24,
  node: [
    ['path', { d: 'M10 10V3', key: 'we2wk2' }],
    ['path', { d: 'M14 10V3', key: 'uvx26u' }],
    ['path', { d: 'M19 13a7 7 0 10-7 7', key: 'ic4q8w' }],
    ['path', { d: 'M5 20h14', key: '1dxev2' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name GeorgianLari
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTBWMyIgLz4KICA8cGF0aCBkPSJNMTQgMTBWMyIgLz4KICA8cGF0aCBkPSJNMTkgMTNhNyA3IDAgMTAtNyA3IiAvPgogIDxwYXRoIGQ9Ik01IDIwaDE0IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/georgian-lari
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GeorgianLari = createLucideIcon(__iconData);

export default GeorgianLari;
